<template>
  <my-dialog title="出入库记录" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
    @close="closeDialog" width="80%">
    
    <div class="item_info border_Green">
      <el-descriptions class="margin-top" title="库存商品信息" :column="4" border>
        <el-descriptions-item>
          <template slot="label">
            商品品牌
          </template>
          {{ wareGoodsInfo.goodsInfo.type }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            商品名称
          </template>
          {{ wareGoodsInfo.goodsInfo.name }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            球镜
          </template>
          {{ wareGoodsInfo.goodsInfo.qiuJing }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            柱镜
          </template>
          {{ wareGoodsInfo.goodsInfo.zhuJing }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            单位
          </template>
          {{ wareGoodsInfo.goodsInfo.unit }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            库存数量
          </template>
          {{ wareGoodsInfo.quantity }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            预警数量
          </template>
          {{ wareGoodsInfo.warningQuantity }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            常备数量
          </template>
          {{ wareGoodsInfo.stockQuantity }}
        </el-descriptions-item>
      </el-descriptions>
      </div>
    <div class="selectContent">
      <el-radio-group v-model.number="selectType" @input="handleInputChange">
        <el-radio-button :label="1">入库记录</el-radio-button>
        <el-radio-button :label="2">出库记录</el-radio-button>
        <el-radio-button :label="3">调库记录</el-radio-button>
      </el-radio-group>
    </div>
    <div>
      <inputRecord ref="inputRecord"></inputRecord>
      <outputRecord ref="outputRecord"></outputRecord>
      <updateQtyRecord ref="updateQtyRecord"></updateQtyRecord>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">关闭</el-button>
    </div>
  </my-dialog>
</template>

<script>
import inputRecord from "./inputRecord.vue";
import outputRecord from "./outputRecord.vue";
import updateQtyRecord from "./updateQtyRecord.vue";
import {GetGoodsWareHouseDetail} from "@/api/storeOrderApi.js";
export default {
  data() {
    return {
      selectType: 1,
      showDialog: false,
      keyId: "",
      wareGoodsInfo: {
        goodsInfo:{}
      },
    };
  },
  // 注册组件
  components: {
    inputRecord,
    outputRecord,
    updateQtyRecord,
  },
  created() { },
  computed: {},
  methods: {
    showRecordDialog(keyId) {
      this.showDialog = true;
      this.selectType = 1;
      this.keyId = keyId;
      this.getGoodsWareHouseDetail();
      this.$nextTick(() => {
        this.$refs.inputRecord.showInputRecordDialog(keyId);
      });
    },
    handleInputChange(val) {
      this.selectType = val;
      if (val == 1) {
        this.$refs.inputRecord.showInputRecordDialog(this.keyId);
        this.$refs.outputRecord.closeOutputDialog();
        this.$refs.updateQtyRecord.closeUpdateQtyRecordDialog();
      } else if (val == 2) {
        this.$refs.inputRecord.closeInputRecordDialog();
        this.$refs.outputRecord.showOutputDialog(this.keyId);
        this.$refs.updateQtyRecord.closeUpdateQtyRecordDialog();
      } else if (val == 3) {
        this.$refs.inputRecord.closeInputRecordDialog();
        this.$refs.outputRecord.closeOutputDialog();
        this.$refs.updateQtyRecord.showUpdateQtyRecordDialog(this.keyId);
      }
    },
    closeDialog() {
      this.$refs.inputRecord.closeInputRecordDialog();
      this.$refs.outputRecord.closeOutputDialog();
      this.$refs.updateQtyRecord.closeUpdateQtyRecordDialog();
      this.keyId = "";
      this.showDialog = false;
    },
    getGoodsWareHouseDetail() {
      GetGoodsWareHouseDetail({
        keyId: this.keyId,
      }).then((res) => {
        if (res.code == 1) {
          this.wareGoodsInfo = res.data;
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      }).catch((err) => {
        this.$message.error("数据加载失败，请稍后再试！");
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.selectContent {
  margin-top: 20rpx;
  display: flex;
  justify-content: center;
  align-items: center;
}
.item_info {
  border-left: 5px solid #55aaff;
  padding: 5px 10px;
  border-radius: 5px;
  margin-bottom: 15px;
  border-bottom: 2px solid #e9e7e7;
}
.border_Green {
  border-left: 5px solid #00cc66;
}
</style>